import(/* webpackMode: "eager" */ "/Users/poojaagrawal/Projects/itellisecure/src/app/prudent/page.tsx");
